import { computed } from 'vue';
import { useSelectedIds } from '@/lib/hooks';
import { useQuery } from '@tanstack/vue-query';

import { fetchUsersSimplifiedByProduct } from '@/api/user';

import {
  USERS_SIMPLIFIED_ID_ROLES_API,
  USERS_SIMPLIFIED_PATENTS_ROLES_API
} from '@/constants/api';

import { PRODUCT_PATENT_PLATFORM } from '@/constants/contentType';

import type {
  UserSimplifiedWithIdRoles,
  UserSimplifiedWithPatentsRoles
} from '@/types/users';

import type { AllowedProducts } from '@/constants/contentType';

function useUsersSimplifiedByProduct(
  useParams = false,
  product: AllowedProducts,
  get_names = true
) {
  const selectedIds = useSelectedIds(useParams);

  const { data, isError, isFetching } = useQuery({
    queryKey: [
      product === PRODUCT_PATENT_PLATFORM
        ? USERS_SIMPLIFIED_PATENTS_ROLES_API
        : USERS_SIMPLIFIED_ID_ROLES_API,
      selectedIds
    ],
    queryFn: () =>
      fetchUsersSimplifiedByProduct({
        user_ids: selectedIds.value,
        product,
        get_names
      }),
    select(data) {
      return data.data;
    }
  });

  const simplifiedUsersWithAccess = computed<SimplifiedUserWithAccess[]>(() => {
    return data.value ?? [];
  });

  return { simplifiedUsersWithAccess, isError, isFetching };
}

export default useUsersSimplifiedByProduct;

export type SimplifiedUserWithAccess =
  | UserSimplifiedWithIdRoles
  | UserSimplifiedWithPatentsRoles;
